import React, { useState } from "react";

const Map = () => {
  // Sử dụng mã Plus Code
  const plusCode = "4JHW+6QG";

  // Thông tin địa điểm đám cưới
  const weddingLocation = {
    plusCode: plusCode,
    name: "Được tổ chức tại tư gia",
    address: "Địa chỉ: 12/127, KV Thới Bình A, P.Thới An, Q.Ô Môn, TP.Cần Thơ",
  };

  // State để theo dõi xem bản đồ có đang hiển thị hay không
  const [showMap, setShowMap] = useState(false);

  // Hàm xử lý khi click vào icon địa điểm
  const handleLocationClick = () => {
    // Mở Google Maps với mã Plus Code
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      plusCode
    )}`;
    window.open(googleMapsUrl, "_blank");
  };

  // Hàm để toggle hiển thị bản đồ nhỏ
  const toggleMapView = () => {
    setShowMap(!showMap);
  };

  return (
    <div className="wedding-map-container">
      <div className="map-header" id="map-header">
        <h3>Địa điểm tổ chức đám cưới</h3>
        <p>{weddingLocation.name}</p>
        <p>{weddingLocation.address}</p>
      </div>

      {/* Icon bản đồ với hiệu ứng hover */}
      <div className="map-icon-container" onClick={toggleMapView}>
        <div className="map-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="48"
            height="48"
            fill="#E25C67"
          >
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
          </svg>
        </div>
        <p>Xem vị trí trên bản đồ</p>
      </div>

      {/* Bản đồ thu nhỏ (hiển thị khi click vào icon) */}
      {showMap && (
        <div className="map-preview">
          <div
            className="map-image"
            onClick={handleLocationClick}
            style={{
              backgroundImage: `url(https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(
                plusCode
              )}&zoom=16&size=600x300&maptype=roadmap&markers=color:red%7C${encodeURIComponent(
                plusCode
              )}&key=YOUR_API_KEY)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
              height: "200px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            <div className="map-overlay">
              <button className="view-on-google-maps">
                Xem trên Google Maps
              </button>
            </div>
          </div>
          <div className="plus-code-info">
            <p>
              Mã Plus Code: <strong>{plusCode}</strong>
            </p>
            <small>Nhấp vào bản đồ để xem chỉ đường chi tiết</small>
          </div>
        </div>
      )}

      <style jsx>{`
        .wedding-map-container {
          font-family: "Arial", sans-serif;
          max-width: 500px;
          margin: 20px auto;
          padding: 15px;
          border-radius: 10px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          background-color: #fff;
        }

        .map-header {
          text-align: center;
          margin-bottom: 15px;
        }

        .map-header h3 {
          color: #e25c67;
          margin-bottom: 5px;
        }

        .map-icon-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          transition: transform 0.3s ease;
        }

        .map-icon-container:hover {
          transform: scale(1.05);
        }

        .map-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: #fff0f3;
          margin-bottom: 10px;
        }

        .map-icon-container p {
          font-size: 14px;
          color: #e25c67;
          font-weight: bold;
        }

        .map-preview {
          margin-top: 15px;
          position: relative;
        }

        .plus-code-info {
          margin-top: 10px;
          text-align: center;
          color: #666;
        }

        .plus-code-info p {
          margin-bottom: 5px;
        }

        .map-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.1);
          opacity: 0;
          transition: opacity 0.3s ease;
          border-radius: 8px;
        }

        .map-image:hover .map-overlay {
          opacity: 1;
        }

        .view-on-google-maps {
          background-color: #e25c67;
          color: white;
          border: none;
          padding: 10px 15px;
          border-radius: 5px;
          font-weight: bold;
          cursor: pointer;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default Map;
